<template>
  <ValidationObserver ref="validationObserver" v-slot="{ errors }" class="w-full flex flex-col justify-start">
    <FormInput
      v-model="config.api_key"
      :readonly="forUser"
      :label="$t('projects.data_adapters.api_key')"
      name="api_key"
      :error="errors.api_key"
      :rules="['required']"
      class="mt-3"
      @update:modelValue="emitPayload"
    />
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'FormbricksConfiguration',
  props: {
    defaultConfig: Object,
    forUser: Boolean,
  },
  data() {
    return {
      config: {
        enabled: true,
        api_key: '',
      },
    };
  },
  computed: {
    projectId() {
      return this.$route.params.projectId;
    },
  },
  methods: {
    ...mapActions(['showToastMessage']),
    validate() {
      return this.$refs.validationObserver.validate();
    },
    emitPayload() {
      this.$emit('update:defaultConfig', this.config);
    },
  },
  watch: {
    defaultConfig: {
      handler() {
        if (this.defaultConfig) {
          this.config = { ...this.config, ...this.defaultConfig };
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
